import { ref } from 'vue';
import { getRawFeedbackByChatbotFlowId } from '@/api/student-voice-score';
import { SVS_FEEDBACK_MODAL_MODE } from '@/consts/svs';

export function useFeedbackModal() {
    // reactive data
    const modalMessages = ref([]);
    const showModal = ref(false);
    const modalMode = ref(SVS_FEEDBACK_MODAL_MODE.RAW);
    const modalCategoryName = ref('');
    const modalSummary = ref('');
    const loadingRawMessages = ref(false);

    // methods
    const messages = (report) => {
        return report?.messages.map((msg) => msg.moderatedMessage);
    };

    const openRawFeedbackModal = async (chatbotFlowId, studentType) => {
        showModal.value = true;
        modalMode.value = 'raw';
        modalCategoryName.value = '';
        modalSummary.value = '';
        loadingRawMessages.value = true;

        try {
            if (chatbotFlowId) {
                const response = await getRawFeedbackByChatbotFlowId({
                    chatbotFlowId,
                    studentType,
                    errorHandlerOptions: {
                        enableAlert: true
                    }
                });

                modalMessages.value = response.messages || [];
            } else {
                // fallback: use sample messages for demo purposes
                modalMessages.value = [
                    'Cost',
                    'Good education/ focus area opportunities but not a lot of scholarships.'
                ];
            }
        } catch (error) {
            console.error('Failed to load raw feedback:', error);
            modalMessages.value = [
                'There was an error loading the raw feedback. Please try again later.'
            ];
        } finally {
            loadingRawMessages.value = false;
        }
    };

    const openAiGeneratedModal = async (categoryName, report) => {
        showModal.value = true;
        modalMode.value = 'ai-generated';
        modalCategoryName.value = categoryName;
        modalSummary.value = report.summary;
        modalMessages.value = messages(report);
        loadingRawMessages.value = false;
    };

    const closeModal = () => {
        showModal.value = false;
        modalMode.value = '';
        modalCategoryName.value = '';
        modalSummary.value = '';
        modalMessages.value = [];
        loadingRawMessages.value = false;
    };

    return {
        // reactive state
        modalMessages,
        showModal,
        modalMode,
        modalCategoryName,
        modalSummary,
        loadingRawMessages,

        // methods
        openRawFeedbackModal,
        openAiGeneratedModal,
        closeModal
    };
}
